import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

// Reference: https://github.com/scttcper/ngx-toastr/blob/master/src/app/pink.toast.ts
@Component({
  selector: 'app-info-toastr',
  templateUrl: './info-toastr.component.html',
  styleUrl: './info-toastr.component.scss'
})

export class InfoToastrComponent extends Toast {
  closeToast(): void {
    this.remove();
  }
}
